import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../_services';
import { CommonDataService } from '../../appDataServices/commonDataService';
import { CommonService } from '../../_services/common.service';

@Component({
  selector: 'contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  companyTel = '';
  isWahl: boolean = false;
  contactUSTemplate = "payEXTemplate";
  loadingTemplate = false;
  constructor(
    public activeModal: NgbActiveModal,
    private commonService: CommonService,
    private commonDataService: CommonDataService,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.loadingTemplate = true;
    if(this.authService.currentUserValue){
      this.commonDataService.getSellersListAndUIConfig().subscribe(data => {
        this.loadingTemplate = false;
        data.forEach(seller => {
          if (seller.contactUSTemplate) {
            this.contactUSTemplate = seller.contactUSTemplate;
          }
          if ((seller.sellerCode || '').toLowerCase() === 'wahl') {
            this.isWahl = true;
          }
        });
        
      }, () => {
        this.loadingTemplate = false;
      });
    }
    // const appSettingsData = this.authService.appSettingsData;
    // if (appSettingsData) {
    //   this.companyTel = appSettingsData && appSettingsData.data && appSettingsData.data.settings && appSettingsData.data.settings.app_settings && appSettingsData.data.settings.app_settings
    //       && appSettingsData.data.settings.app_settings &&  appSettingsData.data.settings.app_settings.setting_data && appSettingsData.data.settings.app_settings.setting_data.misscall;
    // }
    // if(this.authService.currentUserValue.loginData.user.sellerCode === 'WAHL'){
    //   this.isWahl =true;
    // }
  }

  close() {
    this.activeModal.dismiss();
  }

  openUrl(url) {
    this.commonService.openInNewWindow(url, false, () => { });
  }

}
 